import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useAmplitudeContext from '#app/hooks/use-amplitude-context'
import { Icon } from './ui/icon'

const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false)
	let { t } = useTranslation('product_list_page')
	const { trackAmplitudeEvent } = useAmplitudeContext()

	const handleScroll = () => {
		const scrolled = document.documentElement.scrollTop
		setIsVisible(scrolled > 500)
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [])

	const scrollToTop = () => {
		trackAmplitudeEvent('scroll to top button clicked')
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}

	if (!isVisible) return null

	return (
		<button
			onClick={scrollToTop}
			className=" h-12 w-16 rounded-l-full border-2 border-white bg-[#EDEDE7] p-2 shadow-md"
			aria-label={t('scroll_to_top_button')}
		>
			<Icon className="text-2xl text-black" name="chevron-up" />
		</button>
	)
}

export default ScrollToTopButton
